module.exports = __webpack_public_path__ + "static/media/vocal.d8637316.mp3";